import router from '@/router'
import { QueryClient, useQuery } from '@tanstack/vue-query'
import axios from 'axios'
import { computed } from 'vue'

const queryClient = new QueryClient()

export function useWorkspaceQuery(workspaceId?: string) {
  // Track the route param reactively so long-lived components (e.g. the main
  // menu) re-fetch when the user switches workspaces. An explicit workspaceId
  // arg takes precedence and is treated as static.
  const id = computed(
    () => workspaceId ?? (router.currentRoute.value.params['workspaceId'] as string)
  )
  return useQuery({
    queryKey: computed(() => ['workspaces', id.value]),
    enabled: computed(() => !!id.value),
    staleTime: 1000,
    queryFn: () =>
      axios.get('', {
        baseURL: `${import.meta.env.VITE_API_BASE_URL}/w/${id.value}`
      }),
    select: ({ data }: any) => data,
    placeholderData: () => {
      return {
        data: queryClient
          .getQueryData<{ data: { items: any[] } }>(['workspaces'])
          ?.data.items.find((workspace: any) => workspace.id === id.value)
      }
    }
  })
}
